export const ExploreCardSkeleton = () => (
  <div className="relative flex h-[9.625rem] w-full animate-pulse cursor-pointer flex-col items-center overflow-hidden rounded-2xl border border-border bg-gray bg-explore-gradient p-4 text-white lg:h-[19.375rem] lg:w-[23rem] lg:rounded-[2rem] lg:border-2 lg:p-8" />
);

export type Dir = 'asc' | 'desc';
export function multiSort<T>(
  getters: Array<(x: T) => number | string | bigint | boolean | null | undefined>,
  dirs: Dir[],
) {
  return (a: T, b: T) => {
    for (let i = 0; i < getters.length; i++) {
      const get = getters[i];
      const dir = dirs[i] ?? 'asc';

      const A = get(a);
      const B = get(b);

      // Keep undefined/null at the end
      const aU = A === undefined || A === null;
      const bU = B === undefined || B === null;
      if (aU && bU) continue;
      if (aU || bU) return aU ? 1 : -1;

      // TS knows A/B are non-nullish here
      if (A < B) return dir === 'asc' ? -1 : 1;
      if (A > B) return dir === 'asc' ? 1 : -1;
    }
    return 0;
  };
}
